import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { OsiInfoSchema } from '@shared/validation/osi/info';
import { useEffect } from 'react';
import { AnyObjectSchema } from 'yup';

interface UseOsiInfoProps {
  defaultValues: any;
  autoTrigger?: boolean;
  // OSI-821: схема валидации переопределяется (вкладка «Основные данные» — ослабленная), по умолчанию OsiInfoSchema
  schema?: AnyObjectSchema;
}

interface UseOsiInfoReturn {
  hookForm: any;
}

type UseOsiInfoForm = (props: UseOsiInfoProps) => UseOsiInfoReturn;

export const useOsiInfoForm: UseOsiInfoForm = ({ defaultValues, autoTrigger = true, schema = OsiInfoSchema }) => {
  const hookForm = useForm({
    defaultValues,
    resolver: yupResolver(schema),
    mode: 'all'
  });

  const { trigger } = hookForm;

  useEffect(() => {
    if (autoTrigger) {
      trigger();
    }
  }, [autoTrigger, trigger]);

  return {
    hookForm
  };
};
